import { render, staticRenderFns } from "./advert-breadcrumbs.vue?vue&type=template&id=091b80e8"
import script from "./advert-breadcrumbs.vue?vue&type=script&lang=ts"
export * from "./advert-breadcrumbs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports